export var PropertySearchEnum;
(function (PropertySearchEnum) {
    PropertySearchEnum["Address"] = "Address";
    PropertySearchEnum["ErfNumber"] = "Erf number";
    PropertySearchEnum["FarmNumber"] = "Farm number";
    PropertySearchEnum["Allotment"] = "Allotment";
    PropertySearchEnum["PortionNumber"] = "Portion number";
    PropertySearchEnum["SGNumber"] = "SG number";
    PropertySearchEnum["PropertyDescription"] = "Property description";
    PropertySearchEnum["PremiseId"] = "Premise id";
    PropertySearchEnum["AccountNumber"] = "Account Number";
})(PropertySearchEnum || (PropertySearchEnum = {}));
export var PropertyValuationSearchEnum;
(function (PropertyValuationSearchEnum) {
    PropertyValuationSearchEnum["Address"] = "Address";
    PropertyValuationSearchEnum["ErfNumber"] = "Erf number";
    PropertyValuationSearchEnum["FarmNumber"] = "Farm number";
    PropertyValuationSearchEnum["Allotment"] = "Allotment";
    PropertyValuationSearchEnum["PortionNumber"] = "Portion number";
    PropertyValuationSearchEnum["SGNumber"] = "SG number";
    PropertyValuationSearchEnum["PropertyDescription"] = "Property description";
    PropertyValuationSearchEnum["SectionalTitle"] = "Sectional title";
    PropertyValuationSearchEnum["PremiseId"] = "Premise id";
    PropertyValuationSearchEnum["AccountNumber"] = "Account Number";
    PropertyValuationSearchEnum["Zoning"] = "Zoning";
})(PropertyValuationSearchEnum || (PropertyValuationSearchEnum = {}));
export var OwnerSearchEnum;
(function (OwnerSearchEnum) {
    OwnerSearchEnum["OwnerName"] = "Owner name";
    OwnerSearchEnum["OwnerSurname"] = "Owner surname";
    OwnerSearchEnum["OwnerOrganisation"] = "Owner organisation";
    OwnerSearchEnum["OwnerRepresentative"] = "Owner representative";
    OwnerSearchEnum["OwnerOrganisationRegNo"] = "Owner organisation reg no.";
    OwnerSearchEnum["OwnerIDNumber"] = "Owner ID number";
    OwnerSearchEnum["Address"] = "Address";
    OwnerSearchEnum["ErfNumber"] = "Erf number";
    OwnerSearchEnum["SGNumber"] = "SG number";
})(OwnerSearchEnum || (OwnerSearchEnum = {}));
export var ZoningSearchEnum;
(function (ZoningSearchEnum) {
    ZoningSearchEnum["Zoning"] = "Zoning";
    ZoningSearchEnum["Address"] = "Address";
    ZoningSearchEnum["ErfNumber"] = "Erf number";
    ZoningSearchEnum["FarmNumber"] = "Farm number";
    ZoningSearchEnum["Allotment"] = "Allotment";
    ZoningSearchEnum["SGNumber"] = "SG number";
    ZoningSearchEnum["PropertyDescription"] = "Property description";
})(ZoningSearchEnum || (ZoningSearchEnum = {}));
export var RateCertificateSearchEnum;
(function (RateCertificateSearchEnum) {
    RateCertificateSearchEnum["Address"] = "Address";
    RateCertificateSearchEnum["ErfNumber"] = "Erf number";
    RateCertificateSearchEnum["FarmNumber"] = "Farm number";
    RateCertificateSearchEnum["Allotment"] = "Allotment";
    RateCertificateSearchEnum["PortionNumber"] = "Portion number";
    RateCertificateSearchEnum["SGNumber"] = "SG number";
})(RateCertificateSearchEnum || (RateCertificateSearchEnum = {}));
export var BusinessLicenceSearchEnum;
(function (BusinessLicenceSearchEnum) {
    BusinessLicenceSearchEnum["Address"] = "Address";
    BusinessLicenceSearchEnum["ErfNumber"] = "Erf number";
    BusinessLicenceSearchEnum["FarmNumber"] = "Farm number";
    BusinessLicenceSearchEnum["Allotment"] = "Allotment";
    BusinessLicenceSearchEnum["PortionNumber"] = "Portion number";
    BusinessLicenceSearchEnum["SGNumber"] = "SG number";
})(BusinessLicenceSearchEnum || (BusinessLicenceSearchEnum = {}));
